<script lang="ts">
    import ZentitySelect from '../_common/z/zentity-select.svelte'
    import Fa from 'svelte-fa'
    import { faSyncAlt, faPlus } from '@fortawesome/free-solid-svg-icons'
    import { ListsRepository } from '../../modules/pipelineApi/pipeline/lists/lists.repository'
    import { ListsService } from '../../modules/pipelineApi/pipeline/lists/lists.service'
    import type { List as ListEntity } from '../../modules/pipelineApi/pipeline/lists/list'
    import Card from './card.svelte'
    import { DragAndDrop, DragAndDropContainer } from './dragAndDrop/dragAndDrop.js'
    import CardForm from './card-form.svelte'
    import Popover from '../_common/popover.svelte'
    import { CardsRepository } from '../../modules/pipelineApi/pipeline/cards/cards.repository'
    import { CardsService } from '../../modules/pipelineApi/pipeline/cards/cards.service'
    import type { MoveCardDto } from '../../modules/pipelineApi/pipeline/cards/cards-move.dto'
    import { Store } from '../../modules/infra/store.service'
    import { User } from '../../modules/usersApi/users/user'
    import Transition from '../_common/transition.svelte'
    import { flip } from 'svelte/animate'
    import LoadSpinner from '../_common/load-spinner.svelte'
    import { pushAct } from '../_common/stores'
    import { onMount, tick } from 'svelte'
    import Zchart from '../_common/z/zchart.svelte'
    import { ChartData, ChartService } from '../_common/z/zchart'
    import dayjs from 'dayjs'
    import type { EventSource } from '../../modules/eventsApi/event-sources/event-source.entity'
    import Zact from '../_common/z/zact.svelte'

    export let id: string

    let show = false

    let lists: ListEntity[] = []
    let huge = false
    async function loadBoard(id, userId, filter: Status) {
        try {
            show = true

            const listR = new ListsRepository('boards/' + id + '/lists')
            const listS = new ListsService(listR)
            let from: Date = undefined
            let to: Date = undefined
            if (filter === 'today') {
                filter = undefined
                from = new Date()
                from.setHours(0, 0, 0, 0)
                to = new Date()
                to.setHours(0, 0, 0, 0)
                to.setDate(to.getDate() + 1)
                from.setMinutes(from.getMinutes() - from.getTimezoneOffset())
                to.setMinutes(to.getMinutes() - to.getTimezoneOffset() - 1)
            }
            lists = await listS.getAll({ cards: true, userId, filter, from, to })
            let count = 0
            for (const list of lists) {
                count += list.cards.length
            }
            huge = count > 300
            console.log('lists', lists)
            setupDragAndDrop()
            window.flags('pipeline', true, id)
            if (showChart) {
                await loadCharts()
            }
        } finally {
            show = false
        }
    }

    let cardId: string = ''
    let listId: string = ''
    let boardId: string = ''
    let showCard: boolean = false
    function newCard(_boardId, _listId) {
        cardId = ''
        boardId = _boardId
        listId = _listId
        showCard = true
    }

    function newCardSuccess(card) {
        dd.enabled = true
        showCard = false
        listId = ''
        boardId = ''
        query = ''
        refresh()
    }

    function startEditCard(ev) {
        dd.enabled = false
        boardId = id
        cardId = ev.detail.cardId
        listId = ev.detail.listId
        showCard = true
    }

    async function refresh() {
        await loadBoard(id, userId, selectedStatus)
    }

    $: {
        loadBoard(id, userId, selectedStatus)
    }

    // drag'n'drop ============================================
    let dragContainers: DragAndDropContainer[] = []
    let dd = new DragAndDrop()

    dd.callback = async (result) => {
        const endpoint = 'boards/' + id + '/lists/' + result.source.data.id + '/cards'
        const cardR: CardsRepository = new CardsRepository(endpoint)
        const cardS: CardsService = new CardsService(cardR)
        const dto: MoveCardDto = {
            listId: result.destination.data.id,
            position: result.destination.index,
        }
        await cardS.move(result.element.data.id, dto)
        window.api.users.statistics.tick('pipeline.card.move')
        for (const list of lists) {
            for (const card of list.cards) {
                if (card.cardId === result.element.data.id) {
                    card.listId = result.destination.data.id
                    return
                }
            }
        }
    }

    function setupDragAndDrop() {
        if (lists.length > 0) {
            setTimeout(() => {
                clearDragAndDrop()
                for (let index = 0; index < lists.length; index++) {
                    dragContainers.push(new DragAndDropContainer('list_' + index, dd))
                }
            }, 500)
        }
    }

    function clearDragAndDrop() {
        for (const container of dragContainers) {
            container.remove()
        }
        dragContainers = []
    }
    // ================================

    const store = new Store()
    let userId: string = store.token.userId
    let user: User = new User()
    user.userId = store.token.userId
    user.userName = ''

    function userChanged(ev) {
        console.log('ev', ev.detail)
        userId = ev.detail?.userId
    }

    let loaded = false
    pushAct.subscribe((value) => {
        if (!loaded) return
        if (value?.act !== 'pipe_refresh') return
        // no futuro, caso informe o id do pipe, então só carrega se for ele
        if (value.value && String(value.value) !== id) {
            console.log('aborted reload from notif')
            return
        }
        console.log('reload from notif')
        refresh()
    })

    let query: string = ''
    function htmlFilter(termo) {
        const targetListOfElementsID = 'filter-container'
        const elementToBeFilteredID = 'filter-item'
        termo = termo
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
        let content
        let grids = document.querySelectorAll('.' + targetListOfElementsID) as any
        for (const grid of grids) {
            let rows = grid.querySelectorAll('.' + elementToBeFilteredID)
            for (let i = 0; i < rows.length; i += 1) {
                content = rows[i].innerHTML.replace(/<[^>]+>/g, '')
                if (
                    content
                        .normalize('NFD')
                        .replace(/[\u0300-\u036f]/g, '')
                        .toLowerCase()
                        .indexOf(termo) >= 0
                ) {
                    rows[i].setAttribute('style', "display:''")
                } else {
                    rows[i].setAttribute('style', 'display:none !important')
                }
            }
        }
    }

    let delay = null
    async function search(query) {
        if (delay) clearInterval(delay)
        delay = setTimeout(() => {
            htmlFilter(query)
        }, 500)
    }

    $: {
        search(query)
    }

    type Status = 'active' | 'delayed' | 'unscheduled' | 'freezed' | 'finished' | 'canceled' | 'today' | ''
    let selectedStatus: Status = 'active'
    function showByStatus(status: Status) {
        selectedStatus = status
    }

    async function onShowChartChange() {
        if (showChart) {
            show = true
            await loadCharts()
            show = false
        } else {
            for (const chart of charts) {
                chart.chart.destroy()
            }
        }
    }

    let showChart = false
    let charts: ChartService[] = []
    async function loadCharts() {
        for (const chart of charts) {
            chart.chart.destroy()
        }
        let from = new Date()
        from.setHours(0, 0, 0, 0)
        from.setDate(from.getDate() - 7)
        let to = new Date()
        const es: EventSource[] = await window.api.events.eventSources.getAllFromEventSource(from, to, ['cartao_criado', 'cartao_entrou'], true, true)
        console.log('es', es.length, es)
        charts = []
        for (let index = 0; index < lists.length; index++) {
            const data = generateChartData(index, es, from, to)
            const chart = new ChartService()
            chart.bars(data, document.getElementById('chart_' + index))
            charts.push(chart)
        }
    }

    function generateChartData(index: number, es: EventSource[], from: Date, to: Date) {
        const data = evaluteEventSource(index, es, from, to)
        let dto: ChartData = {
            categories: [...data.map((el) => el.label)],
            type: 'bars',
            title: '',
            showGrid: false,
            showToolbar: false,
            showTotals: false,
            height: 120,
            series: [{ data: [...data.map((el) => el.total)] }],
        }
        return dto
    }

    function evaluteEventSource(index: number, es: EventSource[], from: Date, to: Date) {
        let _from = new Date(from)
        let content = []
        while (_from.getTime() < to.getTime()) {
            let day = dayjs(_from).format('D/M')
            if (_from.getDate() === new Date().getDate()) day = 'hoje'
            if (_from.getDate() === new Date().getDate() - 1) day = 'ontem'
            content.push({ label: day, total: 0 })
            _from.setDate(_from.getDate() + 1)
        }
        let persons: { listId: string; personId: string }[] = []
        for (const item of es) {
            if (item.content.includes('Ivanize')) {
                console.log('iv')
            }
            if (!item.content.includes(lists[index].listId)) continue
            if (!lists.some((el) => el.cards.some((el) => el.cardId === item.externalId))) continue
            // impede duplicidade
            if (persons.some((el) => el.personId === item.personId && el.listId === item.externalId)) continue
            persons.push({ personId: item.personId, listId: item.externalId })
            //
            let day = dayjs(item.externalDate).format('D/M')
            if (new Date(item.externalDate).getDate() === new Date().getDate()) day = 'hoje'
            if (new Date(item.externalDate).getDate() === new Date().getDate() - 1) day = 'ontem'
            let found = content.find((el) => el.label === day)
            if (!found) continue
            found.total += 1
        }
        return content
    }

    onMount(() => {
        loaded = true
    })
</script>

<Zact>
    <div class="spacer" />
    <div title="Atualizar" class="btn btn-sm btn-primary" on:click={refresh}><Fa icon={faSyncAlt}></Fa></div>
    <div class="me-2">
        <div class="btn-group" role="group">
            <button type="button" on:click={() => showByStatus('active')} class="btn btn-secondary btn-sm" class:btn-primary={selectedStatus === 'active'}
                >Em andamento</button
            >
            <button type="button" on:click={() => showByStatus('today')} class="btn btn-secondary btn-sm" class:btn-primary={selectedStatus === 'today'}
                >Hoje</button
            >
            <button type="button" on:click={() => showByStatus('delayed')} class="btn btn-secondary btn-sm" class:btn-primary={selectedStatus === 'delayed'}
                >Atrasados</button
            >
            <button
                type="button"
                on:click={() => showByStatus('unscheduled')}
                class="btn btn-secondary btn-sm"
                class:btn-primary={selectedStatus === 'unscheduled'}>Sem lembrete</button
            >
            <button type="button" on:click={() => showByStatus('freezed')} class="btn btn-secondary btn-sm" class:btn-primary={selectedStatus === 'freezed'}
                >Congelados</button
            >
            <button type="button" on:click={() => showByStatus('finished')} class="btn btn-secondary btn-sm" class:btn-primary={selectedStatus === 'finished'}
                >Concluídos</button
            >
            <button type="button" on:click={() => showByStatus('canceled')} class="btn btn-secondary btn-sm" class:btn-primary={selectedStatus === 'canceled'}
                >Cancelados</button
            >
        </div>
    </div>
    <div class="me-2">
        <div class="input-group input-group-sm">
            <label for="" class="input-group-text">Buscar</label>
            <input type="text" bind:value={query} class="form-control" />
        </div>
    </div>
    {#if window.store.token.permissions.pipeline.pipeline.others.read}
        <div class="me-2">
            <ZentitySelect fonte="usuario" on:change={userChanged} value={user} />
        </div>
    {/if}
    <div class="show-chart">
        <div class="form-check form-switch">
            <input class="form-check-input" bind:checked={showChart} on:change={onShowChartChange} type="checkbox" role="switch" id="showChart" />
            <label title="Exibe a quantidade de cartões que entraram em uma etapa nos últimos dias" class="form-check-label" for="showChart"
                >Exibir estatísticas</label
            >
        </div>
    </div>
</Zact>

<div class="board scroll-dark">
    {#if showCard}
        <Popover
            title="Cartão"
            on:close={() => {
                showCard = false
                dd.enabled = true
            }}
        >
            <CardForm
                {boardId}
                {listId}
                {cardId}
                {userId}
                on:edit={startEditCard}
                on:change={(r) => {
                    newCardSuccess(r.detail)
                }}
            />
        </Popover>
    {/if}
    {#each lists as list, l_i}
        <div class="list">
            <div class="list-header nowrap">
                <button
                    on:click={() => {
                        newCard(list.boardId, list.listId)
                    }}><Fa icon={faPlus} /></button
                >
                <div>{list.label} ({list.cards.length})</div>
            </div>
            <div class="list-chart">
                <div id="chart_{l_i}"></div>
            </div>
            <div data-id={list.listId} class="list-body filter-container scroll-dark" id="list_{l_i}">
                {#each list.cards as card, c_i (card.cardId)}
                    <div data-id={card.cardId} class="filter-item pipeline_card_outer" animate:flip={{ duration: 150 }}>
                        {#if !huge}
                            <Transition random={250}>
                                <Card
                                    {card}
                                    index={c_i}
                                    on:edit={startEditCard}
                                    on:change={(r) => {
                                        newCardSuccess(r.detail)
                                    }}
                                />
                            </Transition>
                        {:else}
                            <Card
                                {card}
                                index={c_i}
                                on:edit={startEditCard}
                                on:change={(r) => {
                                    newCardSuccess(r.detail)
                                }}
                            />
                        {/if}
                    </div>
                {/each}
            </div>
        </div>
    {/each}
</div>
<LoadSpinner {show} delay={50} />

<style>
    .list-chart {
        background: #99999910;
        margin: 0px 6px 8px 6px;
        border-radius: 4px;
    }

    .board {
        overflow: hidden;
        display: flex;
        padding: 8px;
        height: 100%;
        user-select: none;
        overflow-x: auto;
    }
    .list {
        border-right: 1px dashed #99999922;
        display: flex;
        flex-direction: column;
        flex: 1 1 310px;
        max-width: 310px;
        min-width: 200px;
    }
    .list-header {
        padding: 4px;
        display: flex;
        margin-bottom: 6px;
        opacity: 0.6;
        flex-shrink: 0;
    }
    .list-header div:first-child {
        flex-grow: 1;
    }
    .list-header button {
        padding: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgb(var(--pipeline-color));
        border-radius: 4px;
        color: white;
        border: 0px;
        margin-right: 8px;
    }
    .list-body {
        overflow-y: hidden;
        flex-grow: 1;
        border-radius: 3px;
        padding-right: 0px;
        padding-left: 6px;
        scrollbar-gutter: stable;
    }
    .list:hover .list-body {
        overflow-y: auto;
        overflow-x: hidden;
    }
    .board > div:last-child {
        border-right: 0px;
    }
    .pipeline_card_outer {
        box-shadow: unset !important;
    }
</style>
